<template>
  <section class="personal-terminal">
    <div class="container">
      <!-- 页面标题 -->
      <header class="page-header">
        <h1>{{ $t('personalTerminal.pageTitle') }}</h1>
        <p class="intro">
          {{ $t('personalTerminal.pageIntro') }}
        </p>
      </header>

      <!-- 内容区块 -->
      <div v-for="(section, index) in sections" :key="index" class="terminal-section">
        <div class="section-card" :class="{ reverse: index % 2 !== 0 }">
          <!-- 图片区域 -->
          <div class="image-area">
            <div class="image-wrapper">
              <img :src="section.image" :alt="section.title" class="section-image" />
              <div class="image-overlay">
                <div class="overlay-icon">
                  <svg v-if="index === 0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                    <line x1="12" y1="18" x2="12.01" y2="18"></line>
                  </svg>
                  <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                  </svg>
                </div>
              </div>
            </div>
            <!-- 装饰元素 -->
            <div class="decoration-circle"></div>
          </div>

          <!-- 文字区域 -->
          <div class="text-area">
            <div class="title-wrapper">
              <h2 class="section-title">{{ section.title }}</h2>
              <!-- <div class="title-decoration"></div> -->
            </div>

            <div class="section-content">
              <p v-for="(paragraph, pIndex) in section.paragraphs" :key="pIndex" class="paragraph">
                <span class="paragraph-icon">●</span>
                {{ paragraph }}
              </p>
            </div>

            <!-- 特性标签 -->
            <!-- <div class="features">
              <span v-for="(feature, fIndex) in section.features" :key="fIndex" class="feature-tag">
                {{ feature }}
              </span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PersonalTerminal",
  data() {
    return {
      images: [
        "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800&q=80",
        "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=800&q=80",
      ],
    };
  },
  computed: {
    sections() {
      return this.$t('personalTerminal.sections').map((section, index) => ({
        ...section,
        image: this.images[index],
      }));
    },
  },
};
</script>

<style scoped>
.personal-terminal {
  padding: 80px 0 100px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面标题 */
.page-header {
  margin-bottom: 80px;
  text-align: center;
}

.page-header h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #1f2d3d;
  margin-top: 40px;
  background: linear-gradient(135deg, var(--header-primary-start), var(--header-primary-end));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-header .intro {
  font-size: 17px;
  line-height: 1.9;
  color: #4a5568;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 内容区块 */
.terminal-section {
  margin-bottom: 80px;
}

.section-card {
  display: flex;
  gap: 60px;
  align-items: center;
  background: white;
  border-radius: 20px;
  padding: 50px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

/* .section-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, var(--header-primary-start), var(--header-primary-end));
} */

.section-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
}

.section-card.reverse {
  flex-direction: row-reverse;
}

/* 图片区域 */
.image-area {
  flex: 0 0 45%;
  position: relative;
}

.image-wrapper {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.section-image {
  width: 100%;
  height: 350px;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.section-card:hover .section-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--header-primary-start), var(--header-primary-end));
  opacity: 0;
  transition: opacity 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-card:hover .image-overlay {
  opacity: 1;
}

.overlay-icon {
  width: 80px;
  height: 80px;
  color: white;
  transform: scale(0.8);
  transition: transform 0.4s ease;
}

.section-card:hover .overlay-icon {
  transform: scale(1);
}

.overlay-icon svg {
  width: 100%;
  height: 100%;
}

/* .decoration-circle {
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--header-primary-start), var(--header-primary-end));
  opacity: 0.1;
  top: -40px;
  right: -40px;
  z-index: -1;
} */

/* 文字区域 */
.text-area {
  flex: 1;
}

.title-wrapper {
  margin-bottom: 28px;
}

.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 12px;
  line-height: 1.3;
}

.title-decoration {
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, var(--header-primary-start), var(--header-primary-end));
  border-radius: 2px;
}

.section-content .paragraph {
  font-size: 16px;
  line-height: 1.9;
  color: #4a5568;
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
  text-align: justify;
}

.paragraph-icon {
  color: #667eea;
  font-size: 12px;
  line-height: 1.9;
  flex-shrink: 0;
  margin-top: 6px;
}

/* 特性标签 */
.features {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
}

.feature-tag {
  padding: 8px 20px;
  background: linear-gradient(135deg, var(--header-primary-start), var(--header-primary-end));
  color: white;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: default;
}

.feature-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 响应式设计 */
@media (max-width: 968px) {
  .section-card,
  .section-card.reverse {
    flex-direction: column;
    padding: 40px 30px;
    gap: 40px;
  }

  .image-area {
    flex: 0 0 auto;
    width: 100%;
  }

  .section-image {
    height: 280px;
  }

  .page-header h1 {
    font-size: 36px;
  }

  .section-title {
    font-size: 26px;
  }
}

@media (max-width: 576px) {
  .personal-terminal {
    padding: 60px 0;
  }

  .section-card {
    padding: 30px 20px;
  }

  .page-header h1 {
    font-size: 32px;
  }

  .page-header .intro {
    font-size: 15px;
  }

  .section-title {
    font-size: 24px;
  }

  .section-content .paragraph {
    font-size: 15px;
  }

  .section-image {
    height: 220px;
  }

  .features {
    gap: 8px;
  }

  .feature-tag {
    padding: 6px 16px;
    font-size: 13px;
  }
}
</style>